import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { PlainButton } from "@culturehq/components";
import client from "@culturehq/client";

import { useProfile, useQueryString } from "app/context";
import { errorService } from "app/utils";

import AddTagButton from "./AddTagButton";

const SuggestedInterest = ({ interest, onInterestAdded, isFeed }) => {
  const { fetchedProfile, profile } = useProfile();
  const history = useHistory();

  const onAdd = useCallback(
    async () => {
      try {
        const response = await client.createProfileUserInterest({ name: interest.name });

        onInterestAdded(interest);
        fetchedProfile({
          ...profile,
          interests: [...profile.interests, response.userInterest.interest]
        });
      } catch (error) {
        errorService.error(error);
      }
    },
    [fetchedProfile, interest, onInterestAdded, profile]
  );

  const { onToggleQueryStringValue } = useQueryString();
  const onClick = () => {
    if (isFeed) {
      onToggleQueryStringValue("i", interest.id);
      return;
    }

    history.push(`/?i=${interest.id}`);
  };

  return (
    <div className="SidePanel__row">
      <p className="clearfix suggested-interests">
        <PlainButton onClick={onClick} disabled={interest.id === -1}>
          {interest.name} ({interest.userCount})
        </PlainButton>
        {profile.interests.every(({ name }) => name !== interest.name) && (
          <AddTagButton onClick={onAdd} />
        )}
      </p>
    </div>
  );
};

export default SuggestedInterest;
